import AppDisclaimer from './AppDisclaimer';

export default AppDisclaimer;
